import { createApp} from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import 'normalize.css'
import './assets/iconfont/iconfont.css'
import './assets/style/style.scss'
import 'ant-design-vue/dist/antd.css'
import * as echarts from 'echarts'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import {utils} from './utils/global.js'

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    // window.pageYOffset = 0
    next()
})

// h5调试
// import Vconsole from 'vconsole'
// console.log(process.env.NODE_ENV)
// if(process.env.NODE_ENV === 'development') {
//   new Vconsole()
// }
// import { customDirective } from './directive/directive'
// 主题样式
// import './assets/style/theme.scss'

import './assets/style/customer.styl'
import './assets/style/font.css'


const app = createApp(App)
app.use(router)
app.use(store)
app.use(Antd)
// app.config.globalProperties.$imgUrl = 'http://hyb-document.hanzhuli.online/'
// app.config.globalProperties.$imgUrl = 'http://cloudcdn.nodepool.cn/'
app.config.globalProperties.$imgUrl = 'http://shsn.innomesh.cn:8012/file/'
app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$utils = utils
// 全局注册directive
// app.directive('custom', customDirective)
NodePlayer.load(()=>{
    app.mount('#app')
})
